import React from 'react';
import { Section } from './ui/Section';
import { smoothScrollToElement } from '../utils/scrollHelpers';
export function ForWho() {
  const points = ['Improvisas cada sesión sin estructura clara', 'No sabes cómo conseguir tus primeros pacientes', 'No tienes documentos legales firmados', 'Te da ansiedad hablar de dinero con pacientes', 'Tu formación fue teórica, la práctica es otro mundo', 'Quieres transmitir autoridad profesional desde ya'];
  const scrollToPricing = () => {
    smoothScrollToElement('pricing');
  };
  return <Section data-id="element-84">
      <h2 className="font-display text-2xl md:text-3xl font-bold text-center mb-6 text-brand-primary" data-id="element-85">
        👀 ESTO ES PARA TI SI...
      </h2>

      <div className="max-w-3xl mx-auto grid md:grid-cols-2 gap-3 mb-6" data-id="element-86">
        {points.map((point, i) => <div key={i} className="bg-white border-l-4 border-red-500 p-4 shadow-sm" data-id="element-87">
            <div className="flex items-start gap-3" data-id="element-88">
              <span className="text-red-500 text-xl shrink-0" data-id="element-89">❌</span>
              <p className="font-body text-brand-text text-sm font-medium" data-id="element-90">
                {point}
              </p>
            </div>
          </div>)}
      </div>

      <div className="text-center max-w-2xl mx-auto bg-brand-accent/10 border-2 border-brand-accent rounded-lg p-6" data-id="element-91">
        <p className="font-heading text-xl font-bold text-brand-primary mb-3" data-id="element-92">
          ¿Te identificaste con 2 o más?
        </p>
        <p className="font-body text-brand-text mb-4 font-semibold" data-id="element-93">
          Este sistema fue diseñado EXACTAMENTE para ti
        </p>
        <button onClick={scrollToPricing} className="bg-gradient-gold hover:opacity-90 text-brand-primary font-body font-bold text-lg py-3 px-8 rounded-lg transition-all hover:shadow-gold" data-id="element-94">
          Ver Ofertas →
        </button>
      </div>
    </Section>;
}